import { DateTime } from 'luxon';
import { ItemLeadTimeFormValues, ItemLeadTime } from '../../types';
import { getLastComment } from '../../utils/commentUtils';

function formatDateForInput(date: string | null | undefined): string {
  if (!date) return '';
  const parsed = DateTime.fromISO(date, { zone: 'utc' });
  if (!parsed.isValid) return '';
  return parsed.toFormat('yyyy-MM-dd');
}

export function getFormDefaults(
  selectedItem: ItemLeadTime | null | undefined,
): ItemLeadTimeFormValues {
  return {
    cost_jr: selectedItem?.cost_jr ?? '',
    cost_plus: selectedItem?.cost_plus ?? '',
    country_of_origin: selectedItem?.country_of_origin ?? '',
    shipment_mode: selectedItem?.shipment_mode ?? '',
    exclusivity: selectedItem?.exclusivity || 'Not Exclusive',
    earliest_custom_cut_delivery_date: formatDateForInput(
      selectedItem?.earliest_custom_cut_delivery_date,
    ),
    custom_cut_lead_time_in_weeks:
      selectedItem?.custom_cut_lead_time_in_weeks ?? '',
    custom_MOQ_jr: selectedItem?.custom_MOQ_jr ?? '',
    custom_MOQ_plus: selectedItem?.custom_MOQ_plus ?? '',
    stock_quantity: selectedItem?.stock_quantity ?? '',
    stock_ratio: selectedItem?.stock_ratio ?? '',
    earliest_IHD_date_to_deliver_stock: formatDateForInput(
      selectedItem?.earliest_IHD_date_to_deliver_stock,
    ),
    incoming_stock_quantity: selectedItem?.incoming_stock_quantity ?? '',
    incoming_stock_ratio: selectedItem?.incoming_stock_ratio ?? '',
    incoming_stock_date: formatDateForInput(selectedItem?.incoming_stock_date),
    comments: getLastComment(selectedItem?.comments),
  };
}
